<template>
	<div style="height:100%">
		<page-header style="height:9%"></page-header>
		<el-container style="height:91%;width:100%;margin:0">
			<page-menu style="width:100%;max-width:185px;height:100%"></page-menu>
			<el-main style="padding:20px 20px;height:100%;width:100%;background-color:#f3f3f3">
				<router-view style="height:98%;margin:0"></router-view>
			</el-main>
		</el-container>
	</div>
</template>
<script>
import pageHeader from './components/headerMenuLogin/pageHeader'
import pageMenu from './components/headerMenuLogin/pageMenu'

export default {
	components: {
		pageHeader,
		pageMenu
	}
}
</script>





// WEBPACK FOOTER //
// src/comprehensivePage.vue